<template>
    <div class="land-promo">
        <div class="promo-pic" :style="'background-image: url(' + salesCard.project_shablon_fields.shablon_main_pic + ')'" v-if="!isMobileChecker"></div>
        <div class="promo-pic-mobile" :style="'background-image: url(' + salesCard.project_shablon_fields.shablon_main_pic_mobile + ')'" v-if="isMobileChecker">
            <div class="promo-title-mobile" v-if="isMobileChecker">
                <h2 v-html="salesCard.project_shablon_fields.shablon_project_title"></h2>
            </div>
        </div>
        <div class="container">
            <div class="land-promo-container">
                <div class="promo-title" v-if="!isMobileChecker">
                    <h2 v-html="salesCard.project_shablon_fields.shablon_project_title"></h2>
                </div>
                <div class="promo-btns-mobile" v-if="isMobileChecker">
                    <ul>
                        <li :class="{'full-view' : salesCard.project_shablon_fields.present_file.file == false &&  lang != 'kz/' || salesCard.project_shablon_fields.present_file.file_kz == false && lang == 'kz/'}">
                            <a href="#" v-scroll-to="{el: '#land-plans', offset: 0}" class="flat-link">{{salesCard.project_shablon_fields.shablon_btn_flat}}</a>
                        </li>
                        <li v-if="salesCard.project_shablon_fields.present_file.file != false && lang != 'kz/'">
                            <a :href="salesCard.project_shablon_fields.present_file.file" target="_blank">{{salesCard.project_shablon_fields.present_file.name}}</a>
                        </li>
                        <li v-if="salesCard.project_shablon_fields.present_file.file_kz != false && lang == 'kz/'">
                            <a :href="salesCard.project_shablon_fields.present_file.file_kz" target="_blank">{{salesCard.project_shablon_fields.present_file.name}}</a>
                        </li>
                        <li class="online-book" v-if="saleItem.project_stie_flats_filter_init == 'true'">
                            <a href="#" v-scroll-to="{el: '#land-plans', offset: 0}" class="book-link">{{salesCard.project_shablon_fields.shablon_btn_book_online}}</a>
                        </li>
                    </ul>
                </div>
                <div class="project-adres-container" :class="{'online-book' : saleItem.project_stie_flats_filter_init == 'true'}">
                    <div class="project-adres">
                        <svgIcon name="pin-map" />
                        <p>{{salesCard.project_shablon_fields.shablon_house_adres}}</p>
                    </div>
                    <li class="online-book" v-if="saleItem.project_stie_flats_filter_init == 'true' && !isMobileChecker">
                        <a href="#" v-scroll-to="{el: '#land-plans', offset: 0}" class="book-link">{{salesCard.project_shablon_fields.shablon_btn_book_online}}</a>
                    </li>
                </div>
                <div class="project-main-info-pins">
                    <div class="pin-item" v-for="(item, index) in salesCard.project_shablon_fields.shablon_main_info_icons" :key="index">
                        <div class="pin-icon">
                            <img :src="item.icon" alt=""> 
                        </div>
                        <div class="pin-info">
                            <strong v-if="index == 'price' && objectDataCRM != null && saleItem.project_stie_shablon_price_flats_init == 'true' && projectNameG != 'landmark'"><span>от</span> {{objectDataCRM.minMeterPrice}} <span>тг/м2</span></strong>
                            <strong v-if="index == 'price' && saleItem.project_stie_shablon_price_flats_init == 'true' && projectNameG == 'landmark' && LDM_complex != null">
                                <!-- <span>от</span> {{objectDataCRM.minMeterPrice}} <span>тг/м2</span> -->
                                <span v-if="lang == ''">от</span>
                                {{ getNumber(LDM_complex) }}
                                <span v-if="lang == ''">тг.</span><span v-if="lang == 'kz/'">тг.бас.</span>
                            </strong>
                            <strong v-if="index == 'price' && objectDataCRM != null && saleItem.project_stie_shablon_price_flats_init == 'false'">По запросу</strong>
                            <strong v-if="index != 'price'">{{item.info}}</strong>
                            <span class="name">{{item.name}}</span>
                        </div>
                        <!-- {{index}} -->
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sale-land-promo',
        components: {
            svgIcon,
        },
        data () {
            return {
                projectNameG: window.host,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            saleItem: 'loadSaleCardItem',
            salesCard: 'loadSalesCardContent',
            objectDataCRM: 'loadObjectDataCrm',
            isMobileChecker: 'loadIsMobileChecker',
            LDM_complex: 'loadLDM_complex',
        }),
        methods: {
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.$store.dispatch('getObjectFromCRM', {
                "complexCodes": [this.saleItem.crm_code]
            })
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-promo.scss';
    @import '@/styles/components/sales/respond/land-promo-respond.scss';
    // @import '@/styles/components/respond/sales-land/land-promo-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-promo-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>